import { type FC } from "react";

import { Segmented } from "@styled/segmented";

import { ReportDownload, TemplateDownload } from "./draft_download";

// "editTemplate": Edit your template, from the file menu; neither switch is on.
export type DraftView = "document" | "template" | "editTemplate";

// Over a Word draft: Report or Template (read-only), then Download for the
// Report or the draft he uploaded. Before a chat writes for the draft, the
// Report is the draft as uploaded, with only his edits (`edited`) typed in.
export const DraftViewControls: FC<{
  projectId: string;
  conversationId?: string;
  edited: boolean;
  templateUrl: string;
  view: DraftView;
  onView(view: DraftView): void;
}> = ({ projectId, conversationId, edited, templateUrl, view, onView }) => (
  <>
    <Segmented
      items={[
        { value: "document", label: "Report" },
        { value: "template", label: "Template" },
      ]}
      selectedValue={view}
      onChange={(value) =>
        onView(value === "template" ? "template" : "document")
      }
    />
    {view === "document" && (conversationId || edited) ? (
      <ReportDownload conversationId={conversationId} projectId={projectId} />
    ) : (
      <TemplateDownload url={templateUrl} projectId={projectId} />
    )}
  </>
);
